const BASE_URL = process.env.REACT_APP_SERVICE_URL;

const appContentEndpoints = {
  getAppContent: (appId) => `/api/${appId}/app-info`,
};

export const getAppContent = async (appId) => {
  try {
    const response = await fetch(
      `${BASE_URL}${appContentEndpoints.getAppContent(appId)}`,
      {
        method: 'GET',
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
